
export default {
  name: "EllipsisItemList",
  props: {
    items: {
      type: Array,
      required: true
      // default: ["1111", "2222", "3333 ", "4444", "dgsdgsdsfsdfdsf", "阿萨德解", "222阿萨德解22", "阿萨德解", "阿萨德解"]
    }
  },
  data() {
    return {
      visibleItems: [], // 当前第一行显示的条目
      overflowItems: [], // 超出宽度，放第二行的条目
      hasEllipsis: false, // 第一行最后一个条目是否显示省略号
      lastItemMaxWidth: "auto", // 第一行最后一个条目的最大宽度限制
      resizeObserver: null // 监听容器尺寸变化的 ResizeObserver 实例
    }
  },
  mounted() {
    // 组件挂载后立即计算显示条目
    this.recalculateVisibleItems()
    // 初始化 ResizeObserver，容器大小变化时重新计算
    this.resizeObserver = new ResizeObserver(() => {
      this.recalculateVisibleItems()
    })
    this.resizeObserver.observe(this.$refs.container)
  },
  beforeUnmount() {
    // 组件卸载时断开 ResizeObserver 监听
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  },
  methods: {
    async recalculateVisibleItems() {
      await this.$nextTick() // 等待 DOM 更新完成

      // 创建一个隐藏的临时容器，用来测量每个item宽度
      const tempContainer = document.createElement("div")
      tempContainer.style.position = "absolute"
      tempContainer.style.visibility = "hidden" // 隐藏，不影响页面
      tempContainer.style.whiteSpace = "nowrap" // 不换行
      tempContainer.style.fontSize = "0.12rem" // 保持字体大小一致
      tempContainer.style.display = "flex" // flex布局
      tempContainer.style.padding = "0"
      tempContainer.style.border = "none"
      tempContainer.style.boxSizing = "border-box"
      document.body.appendChild(tempContainer)

      let usedWidth = 0 // 第一行的宽度
      if (!this.$refs.container) {
        return
      }
      const maxWidth = this.$refs.container?.clientWidth // 容器最大宽度
      const marginRight = 4 // 每个item右边距宽度
      let firstOverflowIndex = -1 // 记录第一行溢出的位置

      // 遍历所有项，计算它们的宽度，直到超出容器宽度
      for (let i = 0; i < this.items.length; i++) {
        const span = document.createElement("span")
        span.style.padding = "0px"
        span.style.marginRight = i === this.items.length - 1 ? "0" : `${marginRight / 100}rem`
        span.style.whiteSpace = "nowrap"
        span.innerText = this.items[i]
        tempContainer.appendChild(span)

        // 计算该item占用宽度
        const spanWidth = span.offsetWidth + (i === this.items.length - 1 ? 0 : marginRight)

        // 判断加上当前item是否超过容器宽度
        if (usedWidth + spanWidth > maxWidth) {
          firstOverflowIndex = i // 找到第一行溢出的位置
          break // 超过容器宽度时停止计算
        }

        usedWidth += spanWidth
      }

      // 移除临时容器
      document.body.removeChild(tempContainer)

      // 根据是否溢出，分配显示和溢出数组，并设置样式状态
      if (firstOverflowIndex > -1) {
        // 第一行显示从第1个元素到第firstOverflowIndex - 1
        this.visibleItems = this.items.slice(0, firstOverflowIndex)

        // 第二行显示从firstOverflowIndex 开始，直到最后一个溢出项
        this.overflowItems = this.items.slice(firstOverflowIndex)

        // 重置 secondLineUsedWidth 用于计算第二行溢出项
        let secondLineUsedWidth = 0
        // 循环第二行，找到第一个溢出的项
        for (let i = 0; i < this.overflowItems.length; i++) {
          const tempContainer = document.createElement("div")
          tempContainer.style.position = "absolute"
          tempContainer.style.visibility = "hidden" // 隐藏，不影响页面
          tempContainer.style.whiteSpace = "nowrap" // 不换行
          tempContainer.style.fontSize = "0.12rem" // 保持字体大小一致
          tempContainer.style.display = "flex" // flex布局
          tempContainer.style.padding = "0"
          tempContainer.style.border = "none"
          tempContainer.style.boxSizing = "border-box"
          document.body.appendChild(tempContainer)
          const span1 = document.createElement("span")
          span1.style.padding = "0px"
          span1.style.marginRight = i === this.overflowItems.length - 1 ? "0" : `${marginRight / 100}rem`
          span1.style.whiteSpace = "nowrap"
          span1.innerText = this.overflowItems[i]
          tempContainer.appendChild(span1)

          const spanWidth1 = span1.offsetWidth + (i === this.overflowItems.length - 1 ? 0 : marginRight)
          // 判断第二行的当前项是否溢出
          if (secondLineUsedWidth + spanWidth1 > maxWidth) {
            // 打印第二行第一个溢出项
            const remainingWidth = maxWidth - secondLineUsedWidth // 计算被截断的宽度
            // console.log("====================================")
            // console.log("第二行第一个溢出项:", this.overflowItems[i])
            // console.log("被截断后的宽度:", remainingWidth)
            // console.log("====================================")
            // 如果被截断后的宽度小于20px，则删除该项
            if (remainingWidth <= 30) {
              console.log("删除当前溢出项及之后的元素:", this.overflowItems[i])
              this.overflowItems.splice(i) // 删除该项及之后的所有元素
              console.log("====================================")
              console.log(this.overflowItems, "vv")
              console.log("====================================")
              break
            }
            break
          }

          secondLineUsedWidth += spanWidth1
        }
      } else {
        // 如果没有溢出项，直接显示全部
        this.visibleItems = [...this.items]
        this.overflowItems = []
      }
    }
  }
}
